/**
 * GA4 Consent Mode v2 helpers.
 *
 * injectConsentDefaults() must be called BEFORE GTM loads so that GA4 picks
 * up the denied state and sends cookieless pings instead of full tracking.
 *
 * grantAnalyticsConsent()  — call when the user accepts analytics (strict tier banner accept).
 * revokeAnalyticsConsent() — call when the user opts out (open tier footer opt-out).
 *                            Keeps GTM loaded but switches GA4 to cookieless pings.
 */

function gtag(...args: unknown[]): void {
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(args);
}

export function injectConsentDefaults(): void {
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];
    const dataLayer = window.dataLayer;
    window.gtag = window.gtag ?? ((...args: unknown[]) => { dataLayer.push(args); });
    gtag("consent", "default", {
        analytics_storage: "denied",
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        wait_for_update: 500,
    });
}

export function grantAnalyticsConsent(): void {
    if (typeof window === "undefined") return;
    gtag("consent", "update", {
        analytics_storage: "granted",
        ad_user_data: "granted",
    });
}

export function revokeAnalyticsConsent(): void {
    if (typeof window === "undefined") return;
    gtag("consent", "update", {
        analytics_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
    });
}
